module.exports = __webpack_public_path__ + "img/pic_update@2x.e0d4108f.png";